import * as React from 'react';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';
import { Content } from '~/Pages/SubjectInfoPage/Components/Content/Content';
import type { SubjectContentTranslations } from '~/Pages/SubjectInfoPage/SubjectContentTranslations.csharp';
import type { SubjectInfoDescriptionViewModel } from '~/Pages/SubjectInfoPage/SubjectInfoDescriptionViewModel.csharp';
import type { SemesterDropdownItem } from '~/Pages/SubjectInfoPage/ViewModel/SemesterDropdownItem.csharp';
import { ActivityIndicator } from '~/Partials/ActivityIndicator/ActivityIndicator';
import styles from './SubjectInfo.module.css';

export interface SubjectInfoProps {
    selectedSemester: SemesterDropdownItem;
    subjectDescription: SubjectInfoDescriptionViewModel;
    isLoading: boolean;
    translations: SubjectContentTranslations;
    onlineSubjectPageUrl: string;
    englishName: string;
    code: string;
    points: number;
    semesterDropdownItems: SemesterDropdownItem[];
    studyLevel: string;
    version: string;
    setCurrentSemester: (newSemester: SemesterDropdownItem) => void;
    setQueryParams: (semester: SemesterDropdownItem) => void;
    placeholder?: HtmlString;
    fetchingError?: string;
    subjectData?: SubjectInfoDescriptionViewModel;
}

export const SubjectInfo: React.FC<SubjectInfoProps> = props => {
    const {
        selectedSemester,
        subjectDescription,
        subjectData,
        isLoading,
        translations,
        fetchingError,
        ...contentProps
    } = props;

    const shouldRenderSubjectDescription =
        selectedSemester.semester.period === subjectDescription.period &&
        selectedSemester.semester.year === subjectDescription.year;

    if (shouldRenderSubjectDescription) {
        return (
            <Content
                subjectInfoDescription={subjectDescription}
                currentSemester={selectedSemester}
                translations={translations}
                {...contentProps}
            />
        );
    }

    return (
        <>
            {subjectData && (
                <Content
                    subjectInfoDescription={subjectData}
                    currentSemester={selectedSemester}
                    translations={translations}
                    {...contentProps}
                />
            )}
            {fetchingError && <div className={styles.Error}>{translations.errorInfo}</div>}
            <ActivityIndicator cover active={isLoading} />
        </>
    );
};
